import VTimeline from './VTimeline'
import VTimelineItem from './VTimelineItem'

export { VTimeline, VTimelineItem }

export default {
  $_ifrontui_subcomponents: {
    VTimeline,
    VTimelineItem,
  },
}
